module.exports = (window.Set.Set = window.Set);